import { AstraBadge, AstraParagraph } from '~/astra'

export const PractitionersDisplay = ({ names }: { names: string[] }) => {
    if (!names.length) return null

    const [first, ...others] = names

    return (
        <div>
            <div className="lg:hidden">
                <AstraBadge text={names.length} size="small" />
            </div>

            {others.length ? (
                <>
                    <div className="hidden xl:block">
                        <AstraParagraph>
                            {first} +{others.length}
                        </AstraParagraph>
                    </div>
                    <div className="hidden lg:block xl:hidden">
                        <AstraBadge text={names.length} size="small" />
                    </div>
                </>
            ) : (
                <div className="hidden lg:block">
                    <AstraParagraph>{first}</AstraParagraph>
                </div>
            )}
        </div>
    )
}
